export default {"src":"/_next/static/media/zoom.77fb3d41.svg","height":48,"width":48};